import React, {Component} from "react";
import './header.css';

class Index extends Component{

  constructor(props) {
    super(props);
    this.state = {
      pages: [
        {"title": "Home","url":"#/"},
        {"title": "Services","url":"#/services"},
        {"title": "About","url":"#/about"},
        {"title": "Contact","url":"#/contact"}
      ],
      pageActive: props.pageActive,
      displayMenu: false

    };
  }

  onDisplayMenu = () => {
    this.setState({
      displayMenu: !this.state.displayMenu
    });
  }
  render() {
    let contentPages = [];
    const {state} = this;
    state.pages.forEach((page, i) => {

      contentPages.push(
        <div onClick={()=>{this.setState({pageActive:i})}} className={`op-menu ${i === this.state.pageActive ? "option-active" : ""}`}>
          <a href={page.url}>{page.title}</a>
        </div>
      );
    });
    return(
      <div  className="App-header">
        <div className={"content-header fd-r"}>
          <div className={"fd-r"}>

            {

              <div className="logo-photo2">
              </div>
            }

          </div>
          <h1  className={"title-header"}>Technological Solutions |Gaviria IT Services|</h1>
          <a onClick={this.onDisplayMenu} href={window.location.hash}>
            <i className={`fas fa-ellipsis-${state.displayMenu ? "v" : "h"} fa-2x `}></i>
          </a>
          <div className={"cnt-img-profile"}>
            <img width="200" alt={"Profile"}
                 src="https://media-exp1.licdn.com/dms/image/C5603AQFS1n-SRAGWLA/profile-displayphoto-shrink_400_400/0?e=1601510400&amp;v=beta&amp;t=-A8neHkz0uFZDALDMU5RQCsE0vltnjbkr0QDmGDJRNk"
                 height="200" id="ember913" className="profile-photo">
            </img>
          </div>
        </div>

        {
          state.displayMenu &&
          <div className={"menu-principal"}>
            <div className={"mp-col-a"}>
              {contentPages}
            </div>
            <div className={"mp-col-b"}>

            </div>

          </div>
        }

      </div>
    );
  }
}

export default Index;